<!-- // https://codepen.io/techniq/pen/rLXwJJ
 -->
<template>
  <text
    :x="x"
    :y="y"
    :width="width"
    :style="inputStyle"
    :dy="dy + 'em'"
    class="wrap-text"
  >
    <tspan
      v-for="(word, index) in lines"
      :key="index"
      :x="x"
      :y="y"
      :dy="`${dy + index*lineHeight}em`"
    >
      {{ word }}
    </tspan>

    <tspan
      v-if="modePercentage"
      :x="x"
      :y="y"
      :dy="`${dy + lines.length*lineHeight}em`"
    >
      {{ percentage }}
    </tspan>
  </text>
</template>

<script>
const props = {
  inputText: String,
  modePercentage: Boolean,
  percentage: String,
  x: Number,
  y: Number,
  dy: Number,
  width: Number,
  inputStyle: Object,
}

export default {
  name: 'WrapText',
  props: props,
  data () {
    return {
      lines: [],
      spaceWidth: null,
      wordsWithComputedWidth: null,
      lineHeight: 1.33,
      maxLines: 4,
    }
  },
  computed: {
    lineWidth () {
      return this.width - 32
    },
  },
  watch: {
    width (oldData, newData) {
      const lines = this.calculateLines()
      const newLineAdded = this.lines.length !== lines.length
      const wordMoved = this.lines.some((line, index) => line.length != lines[index].length)

      // Only update if number of lines or length of any lines change
      if (newLineAdded || wordMoved) {
        this.lines = lines
      }
    },
  },
  mounted () {
    this.calculateWordWidths()
    this.lines = this.calculateLines()
  },
  methods: {
    calculateWordWidths () {
      // Calculate length of each word to be used to determine number of words per line
      const words = this.inputText.split(/\s+/)
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
      const text = document.createElementNS('http://www.w3.org/2000/svg', 'text')
      Object.assign(text.style, this.inputStyle)

      svg.appendChild(text)
      document.body.appendChild(svg)

      this.wordsWithComputedWidth = words.map((word) => {
        text.textContent = word
        return {word, width: text.getComputedTextLength()}
      })

      text.textContent = '\u00A0' // Unicode space
      this.spaceWidth = text.getComputedTextLength()

      document.body.removeChild(svg)

      return null
    },
    calculateLines () {
      const wordsByLines = this.wordsWithComputedWidth.reduce((result, {word, width}) => {
        const lastLine = result[result.length - 1] || {words: [], width: 0}

        if (lastLine.words.length === 0) {
          // First word on line
          const newLine = {words: [word], width}
          result.push(newLine)
        } else if (lastLine.width + width + (lastLine.words.length * this.spaceWidth) < this.lineWidth) {
          // Word can be added to an existing line
          lastLine.words.push(word)
          lastLine.width += width
        } else {
          // Word too long to fit on existing line
          const newLine = {words: [word], width}
          result.push(newLine)
        }

        return result
      }, [])

      let lines = wordsByLines.map((line) => line.words.join(' '))

      if (lines.length > this.maxLines) {
        lines = lines.slice(0, this.maxLines)
        lines[lines.length - 1] = lines[lines.length - 1] + '...'
      }

      return lines
    },
  },
}
</script>
